<template>
  <div class="h-[42px] mt-7 mb-6"></div>
  <BaseLayoutItemGrid>
    <template #list-items>
      <template v-for="num in 12" :key="num">
        <LoaderCard />
      </template>
    </template>
  </BaseLayoutItemGrid>
</template>
